<template>
  <v-row>
    <v-col
      cols="12"
      md="12"
    >
      <v-card
        outlined
        shaped
        elevation="5"
        class="mx-auto"
      >
        <v-card-actions>
          Filters
          <v-spacer />
          <v-btn
            icon
            @click="show = !show"
          >
            <v-icon>{{ show ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <div v-show="show">
            <v-divider />
            <v-card-text>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="search"
                    label="Search Device ID"
                    color="secondary"
                    hide-details
                    class="mb-2"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-select
                    v-model="selectedVenues"
                    color="secondary"
                    item-color="secondary"
                    label="Venues"
                    multiple
                    item-text="name"
                    item-value="id"
                    :items="venues"
                    clearable
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-select
                    v-model="selectedType"
                    color="secondary"
                    item-color="secondary"
                    label="Portals"
                    item-text="type"
                    :items="types"
                    clearable
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-select
                    v-model="selectedRole"
                    color="secondary"
                    item-color="secondary"
                    label="Role"
                    item-text="role"
                    :items="roles"
                    clearable
                  />
                </v-col>
              </v-row>
              <v-row
                justify="end"
                align-content="end"
              >
                <v-btn
                  small
                  color="success"

                  @click="handleSearch()"
                >
                  search
                </v-btn>
                <v-btn
                  small
                  @click="resetFilters()"
                >
                  clear
                </v-btn>
              </v-row>
            </v-card-text>
          </div>
        </v-expand-transition>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  import { getfilterOptions } from '@/services/portals.js'
  export default {
    data () {
      return {
        show: false,
        search: '',
        venues: [],
        selectedVenues: [],
        selectedType: '',
        selectedRole: '',
        types: [],
        roles: [],
      }
    },
    mounted () {
      this.getFilters()
    },
    methods: {
      handleSearch () {
        const params = {
          device_id: this.search,
          venues: this.selectedVenues,
          portal_type: this.selectedType == null ? '' : this.selectedType,
          portal_role: this.selectedRole == null ? '' : this.selectedRole,
        }
        this.$emit('handleSearchChild', params)
      },
      resetFilters () {
        this.search = ''
        this.selectedVenues = []
        this.selectedType = ''
        this.selectedRole = ''
        const params = {
          device_id: this.search,
          venues: this.selectedVenues,
          portal_type: this.selectedType,
          portal_role: this.selectedRole,
        }
        this.$emit('handleSearch', params)
      },
      getFilters () {
        getfilterOptions().then((res) => {
          this.venues = res.data.obj.venues
          this.types = res.data.obj.types
          this.roles = res.data.obj.roles
        })
      },
    },
  }
</script>
